// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@ces/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@ces/XDL/constants";
import { layoutContainer, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

const footerContainerBreakPoint = 1257;

footerContainerStyles.widgetGridContainer = {
    css: css`
        position: relative;
        ${({ isAuthenticated }: any) => {
            if (isAuthenticated) {
                return css`
                    & .footer-subscribe {
                        display: none;
                    }
                `;
            }
        }}
        .grid-container {
            ${layoutContainer}
            padding-bottom: 16px;
            ${({ isAuthenticated, checkoutView }: any) => {
                if (isAuthenticated && !checkoutView) {
                    return css`
                        padding-top: 24px;
                        & .footer-subscribe {
                            display: none;
                        }
                    `;
                }
                if (checkoutView) {
                    return css`
                        padding-top: 0;
                    `;
                }
                return css`
                    padding-top: 62px;
                    ${xScreen("lte", "md")} {
                        padding-top: 24px;
                    }
                `;
            }}
            display: grid;
            grid-template-areas:
                "leftSection linksSection"
                "leftSection socialLinks"
                "bottomSection bottomSection";

            grid-template-columns: 430px minmax(0, 1fr);
            grid-gap: 0 22px;
            ${xScreen("lte", footerContainerBreakPoint)} {
                grid-template-columns: repeat(2, minmax(0, 1fr));
                grid-template-areas:
                    "leftSection linksSection"
                    "leftSection linksSection"
                    "socialLinks socialLinks"
                    "bottomSection bottomSection";
            }
            ${xScreen("lte", "md")} {
                grid-gap: 0 20px;
            }
            ${xScreen("lte", "sm")} {
                grid-template-columns: minmax(0, 1fr);
                grid-template-areas:
                    "leftSection"
                    "linksSection"
                    "socialLinks"
                    "bottomSection";
            }
        }
    `,
};

footerContainerStyles.subscribeGridItem = {
    css: css`
        width: 100%;
        &:not(.CMS-Mode) {
            position: absolute;
            ${xScreen("lte", "md")} {
                position: relative;
            }
        }
    `,
};
footerContainerStyles.leftSection = {
    css: css`
        grid-area: leftSection;
    `,
};

footerContainerStyles.bottomSection = {
    css: css`
        grid-area: bottomSection;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        margin-top: 16px;
        flex-wrap: wrap;
        row-gap: 16px;
        & .list-wrapper {
            padding: 0;
        }
        ${xScreen("lte", "md")} {
            margin-top: 16px;
        }
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

footerContainerStyles.logoWrapper = {
    css: css`
        width: 100%;
        & .img-wrapper {
            &,
            img,
            picture {
                height: 74px;
                overflow: Hidden;
                ${xScreen("lte", "md")} {
                    height: 62px;
                }
                ${xScreen("lte", "xs")} {
                    height: 56px;
                }
            }
        }
        &.CMS-Mode {
            height: auto;
        }
    `,
};

footerContainerStyles.linksWrapper = {
    css: css`
        width: 100%;
        display: flex;
        grid-area: linksSection;
        gap: 22px;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            grid-template-areas: "linkList1GridItem linkList2GridItem" "linkList3GridItem linkList4GridItem";
            grid-gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            margin-top: 24px;
        }
    `,
};
footerContainerStyles.socialLinksGridItem = {
    css: css`
        grid-area: socialLinks;
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
        flex-wrap: wrap;
        row-gap: 24px;
        &,
        & picture {
            height: 32px;
        }
        & > ${DivWrapper} {
            width: auto;
        }
        ${xScreen("lt", "sm")} {
            justify-content: flex-start;
            height: auto;
            & > ${DivWrapper} > div {
                gap: 16px;
            }
        }
        &.CMS-Mode {
            flex-wrap: nowrap;
        }
    `,
};

footerContainerStyles.linkList1GridItem = {
    css: css`
        grid-area: linkList1GridItem;
        flex: 1;
    `,
};

footerContainerStyles.linkList2GridItem = {
    css: css`
        grid-area: linkList2GridItem;
        flex: 1;
    `,
};

footerContainerStyles.linkList3GridItem = {
    css: css`
        grid-area: linkList3GridItem;
        flex: 1;
    `,
};

footerContainerStyles.linkList4GridItem = {
    css: css`
        grid-area: linkList4GridItem;
        flex: 1;
    `,
};

footerContainerStyles.copyrightText = {
    size: 12,
    css: css`
        letter-spacing: 0;
        line-height: 13px;
    `,
};
